import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Login from "../pages/login/index";
import SignUp from "../pages/login/signUp";
import Salesman from "../pages/salesman/Salesman";
import ErrorPage from "../pages/common/error";
import URL_MAPPING from "./constants";
import CustomerTable from "../pages/employee/index";
import DashboardZamzam from "../pages/zamzam/Dashboardzamzam";
import Finance from "../pages/zamzam/Finance";
import Dashboard from "../pages/dashboard/index";
import SDRDashboard from "../pages/sdr_dashboard/index";
import CustomerDetails from "../pages/customer_details/customer_details";
import TerritoryPlanner from "../pages/territory";
import ResetPass from "../pages/login/resetPass";
import GoogleAuth from "../pages/login/googleAuth";
import DeliveryLocationForm from "../pages/delivery_location_form";
import Landing from "../pages/landing/index";
import Cookies from "js-cookie";
import DashboardAnalytics from "../pages/dashboard_analytics/index";
import EmployeeTable from "../pages/employee/index";
import MasterList from "../pages/customer_details/masterList";
import SupervisorActivityReport from "../pages/supervisor_activity_report/index";
import SupervisorCollectionAudit from "../pages/supervisor_collection_audit/index";
import DashboardKpi from "../pages/dashboard_target/index";
import SupervisorCustomerCreation from "../pages/supervisor_customer_creation/index";
import SupervisorLocationCapture from "../pages/supervisor_location_capture_report";
import SupervisorPOReport from "../pages/supervisor_po_report/index";
import SupervisorCollectionReport from "../pages/supervisor_collection_report/index";
import SupervisorVisitReport from "../pages/supervisor_visit_summary_report/index";
import B2BReport from "../pages/b2b_report";
import B2BFeedbackReport from "../pages/b2b_feedback_report";
import SFAFeedbackCustomerReport from "../pages/feedback_customer_report";
import B2BDashboard from "../pages/b2b_dashboard/index";
import Planogram from "../pages/planogram/index";
import Notifications from "../pages/notification_screen/index";
import VisitReport from "../pages/visit_report/index";
import VideoViewReport from "../pages/video_view_report/index";
import DepositReport from "../pages/deposit_report/index";
import SalesReport from "../pages/sales_summary/index";
import InvoiceReport from "../pages/invoice_report/index";
import MapView from "../pages/map_view/MapView";
import SupervisorMapView from "../pages/map_view/MapView";
import KAKRReport from "../pages/ka_kr_survey_report/index";
import DeliveryReport from "../pages/delivery_driver/delivery_report/index";
import ROLE_GROUPS from "./roles";
import { getUserInfo } from "../utility";
import DeliveryDashboard from "../pages/delivery_driver/dashboard/index";
import RejectionReport from "../pages/delivery_driver/rejection_report/index";
import IventoryZamZam from "../pages/zamzam/IventoryZamZam";
import CreateOrderZamZam from "../pages/zamzam/CreateOrderZamZam";
import AgingReport from "../pages/aging_report/index";
import OrderHistory from "../pages/zamzam/OrderHistory";
import ManageAddr from "../pages/zamzam/ManageAddr";
import StockReport from "../pages/ka_kr_stock_report";
import Survey from "../pages/zamzam/Pages/Survey";
import Dynamic from "../pages/zamzam/Pages/DynamicPage";
import NewCreateOrder from "../pages/zamzam/NewCreateOrder";
import Employees from "../pages/admin_panel/Pages/Employees";
import Customers from "../pages/admin_panel/Pages/Customers";
import EditEmployee from "../pages/admin_panel/Pages/EditEmployee";
import EditCustomer from "../pages/admin_panel/Pages/EditCustomer";
import Offers from "../pages/admin_panel/Pages/Offers";
import AddNewOffer from "../pages/admin_panel/Pages/AddNewOffer";
import EditOffer from "../pages/admin_panel/Pages/EditOffer";
import StorageMapping from "../pages/admin_panel/Pages/StorageMapping";
import AddNewMapping from "../pages/admin_panel/Pages/AddNewMapping";
import Territory from "../pages/admin_panel/Pages/Territory";
import Media from "../pages/admin_panel/Pages/Media";
import AddNewMedia from "../pages/admin_panel/Pages/AddNewMedia";
import EditMedia from "../pages/admin_panel/Pages/EditMedia";
import TrainingVideos from "../pages/admin_panel/Pages/TrainingVideos";
import AddTrainingVideo from "../pages/admin_panel/Pages/AddTrainingVideo";
import EditTrainingVideo from "../pages/admin_panel/Pages/EditTrainingVideo";
import EditTerritory from "../pages/admin_panel/Pages/EditTerritory";
import EditPerm from "../pages/admin_panel/Pages/EditPerm";
import EditSales from "../pages/admin_panel/Pages/EditSales";
import EditMonthly from "../pages/admin_panel/Pages/EditMonthly";
import AddNewTerritory from "../pages/admin_panel/Pages/AddNewTerritory";
import CreateDummyTerritory from "../pages/admin_panel/Pages/CreateDummyTerritory";
import AddSales from "../pages/admin_panel/Pages/AddSales";
import AddRules from "../pages/admin_panel/Pages/AddRules";
import AddPermsions from "../pages/admin_panel/Pages/AddPermissions";
import Assignrole from "../pages/admin_panel/Pages/Assignrole";
import EMPLOYEEMONTHLY from "../pages/admin_panel/Pages/EMPLOYEEMONTHLY";
import AddNewMonthlyTarget from "../pages/admin_panel/Pages/AddNewMonthlyTarget";
import UploadMonthly from "../pages/admin_panel/Pages/UploadMonthly";
import Config from "../pages/admin_panel/Pages/Config";
import EditConfig from "../pages/admin_panel/Pages/EditConfig";
import AddConfig from "../pages/admin_panel/Pages/AddConfig";
import Activation from "../pages/admin_panel/Pages/Activation";
import Report from "../pages/admin_panel/Pages/Report";
import AddRolesReport from "../pages/admin_panel/Pages/AddRolesReport";
import Notif from "../pages/admin_panel/Pages/Notif";
import MasterSync from "../pages/admin_panel/Pages/MasterSync";
import RoadnetSync from "../pages/admin_panel/Pages/RoadnetSync";
import RoutePlanningGenerate from "../pages/admin_panel/Pages/RoutePlanningGenerate";
import Auth from "../pages/admin_panel/Pages/Auth";
import RoleEmployee from "../pages/admin_panel/Pages/RoleEmployee";
import RolePermissions from "../pages/admin_panel/Pages/RolePermissions";
import Sales from "../pages/admin_panel/Pages/SalesRule";
import EditOrderHistory from "../pages/zamzam/Pages/EditOrderHistory";
import SDRActivityReport from "../pages/sdr_activity_report";
import SDRVisitReport from "../pages/sdr_visit_summary_report";
import SupervisorDashboard from "../pages/supervisor_dashboard";
import CallPlanReport from "../pages/call_plan_report";
import SDRSummaryReport from "../pages/sdr_summary_report";
import OtpGeneration from "../pages/otp_generation";
import OTPCheckinReport from "../pages/delivery_driver/otp_checkin_report";
import DeliveryImagesReport from "../pages/delivery_driver/delivery_images_report";
import SDRActivityReport40 from "../pages/sdr_activity_report_40";
import HorecaVisitSummaryReport from "../pages/horeca_visit_summary_report";
import HorecaActivityReport from "../pages/horeca_activity_report";
import ShopLicenseReport from "../pages/shop_license_report";
import TerritoryMapView from "../pages/territorymapview";
import AssignLMDTeeritory from "../pages/admin_panel/Pages/AssignLMDTeeritory";
import LMDTerritory from "../pages/admin_panel/Pages/LMDTerritory";
import DeliverySummaryReport from "../pages/delivery_summary_report";
import DeliveryHeatmap from "../pages/delivery_heatmap";
import HorecaCollectionReport from "../pages/horeca_collection_report";
import HorecaStockReport from "../pages/horeca_stock_report";
import HorecaQuaterlyConfirmationReport from "../pages/horeca_quaterly_confirmation_report";
import HorecaCustomerVisitSummaryReport from "../pages/customer_visit_report";
import PlanningReport from "../pages/delivery_driver/planning_report";
import RescheduledDeliveryReport from "../pages/delivery_driver/rescheduled_delivery_report";
import ResetTrip from "../pages/reset_trip";
interface ProtectedRouteProps {
  component: React.ComponentType<any>;
  [key: string]: any; // To accept any additional props
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  allowedRoles = [],
  ...rest
}) => {
  const isAuthenticated = Cookies.get("token");
  const userRoles = getUserInfo();

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  if (userRoles) {
    const user_info = getUserInfo();

    if (user_info.role === "NWC") {
      const hasAccess =
        userRoles?.nwc_role &&
        userRoles.nwc_role.some((role: any) => allowedRoles.includes(role));

      if (!hasAccess) {
        return <Navigate to="*" replace />;
      }
    }

    return <Component {...rest} />;
  } else {
    const hasAccess = allowedRoles?.includes(userRoles?.role);

    if (!hasAccess) {
      return <Navigate to="*" replace />;
    }
  }
  return <Component {...rest} />;
};

const AllRoutes: React.FunctionComponent = () => {
  return (
    <Routes>
      <Route path={URL_MAPPING.LOGIN} element={<Login />} />
      <Route path={URL_MAPPING.LOGIN_ROOT} element={<Login />} />
      <Route path={URL_MAPPING.SIGNUP} element={<SignUp />} />
      <Route path={URL_MAPPING.RESETPASS} element={<ResetPass />} />
      <Route path={URL_MAPPING.GOOGLEAUTH} element={<GoogleAuth />} />
      <Route
        path={URL_MAPPING.UPDATE_LOCATION}
        element={<DeliveryLocationForm />}
      />
      <Route path="*" element={<ErrorPage />} />

      {/* protected routes */}
      <Route
        path={URL_MAPPING.ANALYTICS}
        element={
          <ProtectedRoute
            component={DashboardAnalytics}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SALESMAN}
        element={
          <ProtectedRoute
            component={Salesman}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ACTIVITYREPORT}
        element={
          <ProtectedRoute
            component={CustomerTable}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.DASHBOARD}
        element={
          <ProtectedRoute
            component={Dashboard}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.CUSTOMERLISTDETAILS}
        element={
          <ProtectedRoute
            component={CustomerDetails}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.TERRITORIES}
        element={
          <ProtectedRoute
            component={TerritoryPlanner}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.TERRITORYMAPVIEW}
        element={
          <ProtectedRoute
            component={TerritoryMapView}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.EMPLOYEEMONTHLY}
        element={
          <ProtectedRoute
            component={EMPLOYEEMONTHLY}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />

      <Route
        path={URL_MAPPING.LANDING}
        element={
          <ProtectedRoute
            component={Landing}
            allowedRoles={[
              ...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR,
              ...ROLE_GROUPS.DELIVERY_DRIVER,
            ]}
          />
        }
      />
      <Route
        path={URL_MAPPING.AGINGREPORT}
        element={
          <ProtectedRoute
            component={AgingReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />

      <Route
        path={URL_MAPPING.EMPLOYEETABLE}
        element={
          <ProtectedRoute
            component={EmployeeTable}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />

      <Route
        path={URL_MAPPING.MASTERLIST}
        element={
          <ProtectedRoute
            component={MasterList}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />

      <Route
        path={URL_MAPPING.PLANOGRAM}
        element={
          <ProtectedRoute
            component={Planogram}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.NOTIFICATIONS}
        element={
          <ProtectedRoute
            component={Notifications}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.VISITREPORT}
        element={
          <ProtectedRoute
            component={VisitReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.VIDEO_VIEW_REPORT}
        element={
          <ProtectedRoute
            component={VideoViewReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.DEPOSITREPORT}
        element={
          <ProtectedRoute
            component={DepositReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SALESREPORT}
        element={
          <ProtectedRoute
            component={SalesReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.B2BREPORT}
        element={
          <ProtectedRoute
            component={B2BReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.B2BFEEDBACKREPORT}
        element={
          <ProtectedRoute
            component={B2BFeedbackReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SFAFEEDBACKCUSTOMERREPORT}
        element={
          <ProtectedRoute
            component={SFAFeedbackCustomerReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SHOPLICENSEREPORT}
        element={
          <ProtectedRoute
            component={ShopLicenseReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.B2BDASHBOARD}
        element={
          <ProtectedRoute
            component={B2BDashboard}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.INVOICEREPORT}
        element={
          <ProtectedRoute
            component={InvoiceReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />

      <Route
        path={URL_MAPPING.MAPVIEW}
        element={
          <ProtectedRoute
            component={MapView}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SDRDASHBOARD}
        element={
          <ProtectedRoute
            component={SDRDashboard}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />

      <Route
        path={URL_MAPPING.SDRACTIVITYREPORT}
        element={
          <ProtectedRoute
            component={SDRActivityReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SDRACTIVITYREPORT40}
        element={
          <ProtectedRoute
            component={SDRActivityReport40}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SDRVISITREPORT}
        element={
          <ProtectedRoute
            component={SDRVisitReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SDRSUMMARYREPORT}
        element={
          <ProtectedRoute
            component={SDRSummaryReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.HORECAVISITREPORT}
        element={
          <ProtectedRoute
            component={HorecaVisitSummaryReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.CUSTOMERVISITSREPORT}
        element={
          <ProtectedRoute
            component={HorecaCustomerVisitSummaryReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.RESETTRIP}
        element={
          <ProtectedRoute
            component={ResetTrip}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.HORECACOLLECTIONREPORT}
        element={
          <ProtectedRoute
            component={HorecaCollectionReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.HORECASTOCKREPORT}
        element={
          <ProtectedRoute
            component={HorecaStockReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.HORECAQUATERLYCONFIRMATIONREPORT}
        element={
          <ProtectedRoute
            component={HorecaQuaterlyConfirmationReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.HORECAACTIVITYREPORT}
        element={
          <ProtectedRoute
            component={HorecaActivityReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.CALLPLANREPORT}
        element={
          <ProtectedRoute
            component={CallPlanReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.DELIVERYDASHBOARD}
        element={
          <ProtectedRoute
            component={DeliveryDashboard}
            allowedRoles={[...ROLE_GROUPS.DELIVERY_DRIVER]}
          />
        }
      />
      <Route
        path={URL_MAPPING.DELIVERYREPORT}
        element={
          <ProtectedRoute
            component={DeliveryReport}
            allowedRoles={[...ROLE_GROUPS.DELIVERY_DRIVER]}
          />
        }
      />
      <Route
        path={URL_MAPPING.DELIVERYSUMMARYREPORT}
        element={
          <ProtectedRoute
            component={DeliverySummaryReport}
            allowedRoles={[...ROLE_GROUPS.DELIVERY_DRIVER]}
          />
        }
      />
      <Route
        path={URL_MAPPING.RESCHEDULEDDELIVERYREPORT}
        element={
          <ProtectedRoute
            component={RescheduledDeliveryReport}
            allowedRoles={[...ROLE_GROUPS.DELIVERY_DRIVER]}
          />
        }
      />
      <Route
        path={URL_MAPPING.DELIVERYIMAGESREPORT}
        element={
          <ProtectedRoute
            component={DeliveryImagesReport}
            allowedRoles={[...ROLE_GROUPS.DELIVERY_DRIVER]}
          />
        }
      />
      <Route
        path={URL_MAPPING.PLANNINGREPORT}
        element={
          <ProtectedRoute
            component={PlanningReport}
            allowedRoles={[...ROLE_GROUPS.DELIVERY_DRIVER]}
          />
        }
      />
      <Route
        path={URL_MAPPING.OTPCHECKINREPORT}
        element={
          <ProtectedRoute
            component={OTPCheckinReport}
            allowedRoles={[...ROLE_GROUPS.DELIVERY_DRIVER]}
          />
        }
      />
      <Route
        path={URL_MAPPING.REJECTIONREPORT}
        element={
          <ProtectedRoute
            component={RejectionReport}
            allowedRoles={[...ROLE_GROUPS.DELIVERY_DRIVER]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ADMINPANEL}
        element={
          <ProtectedRoute
            component={Employees}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.CUSTOMERS}
        element={
          <ProtectedRoute
            component={Customers}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.EDITEMPLOYEE(":id")}
        element={
          <ProtectedRoute
            component={EditEmployee}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.EDITCUSTOMER(":id")}
        element={
          <ProtectedRoute
            component={EditCustomer}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.OFFERS}
        element={
          <ProtectedRoute
            component={Offers}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ADDNEWOFFERS}
        element={
          <ProtectedRoute
            component={AddNewOffer}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.EDITOFFER(":id")}
        element={
          <ProtectedRoute
            component={EditOffer}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.STORAGEMAPPING}
        element={
          <ProtectedRoute
            component={StorageMapping}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.CREATESTOREAGEMAPPING}
        element={
          <ProtectedRoute
            component={AddNewMapping}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.MEDIA}
        element={
          <ProtectedRoute
            component={Media}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.EDITMEDIA(":id")}
        element={
          <ProtectedRoute
            component={EditMedia}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ADDNEWMEDIA}
        element={
          <ProtectedRoute
            component={AddNewMedia}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.TRAININGVIDEOS}
        element={
          <ProtectedRoute
            component={TrainingVideos}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ADDTRAININGVIDEO}
        element={
          <ProtectedRoute
            component={AddTrainingVideo}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.EDITTRAININGVIDEO(":id")}
        element={
          <ProtectedRoute
            component={EditTrainingVideo}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.UPLOADMONTHLY}
        element={
          <ProtectedRoute
            component={UploadMonthly}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.TERRITORY}
        element={
          <ProtectedRoute
            component={Territory}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.EDITTERRITORY(":id")}
        element={
          <ProtectedRoute
            component={EditTerritory}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.EDITPERM(":id")}
        element={
          <ProtectedRoute
            component={EditPerm}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />


      <Route
        path={URL_MAPPING.EDITSALES(":id")}
        element={
          <ProtectedRoute
            component={EditSales}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.EDITMONTHLY(":id")}
        element={
          <ProtectedRoute
            component={EditMonthly}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ADDNEWTERRITORY}
        element={
          <ProtectedRoute
            component={AddNewTerritory}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.CREATEDUMMYTERRITORY}
        element={
          <ProtectedRoute
            component={CreateDummyTerritory}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ADDSALES}
        element={
          <ProtectedRoute
            component={AddSales}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ADDRULES}
        element={
          <ProtectedRoute
            component={AddRules}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ADDPERMISSIONS(":id")}
        element={
          <ProtectedRoute
            component={AddPermsions}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ASSIGNROLE(":id")}
        element={
          <ProtectedRoute
            component={Assignrole}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ADDNEWMONTHLYTARGET}
        element={
          <ProtectedRoute
            component={AddNewMonthlyTarget}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />

      <Route
        path={URL_MAPPING.CONFIG}
        element={
          <ProtectedRoute
            component={Config}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />

      <Route
        path={URL_MAPPING.EDITCONFIG(":id")}
        element={
          <ProtectedRoute
            component={EditConfig}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />

      <Route
        path={URL_MAPPING.ADDCONFIG}
        element={
          <ProtectedRoute
            component={AddConfig}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />

      <Route
        path={URL_MAPPING.ACTIVATION}
        element={
          <ProtectedRoute
            component={Activation}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />

      <Route
        path={URL_MAPPING.REPORT}
        element={
          <ProtectedRoute
            component={Report}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />

      <Route
        path={URL_MAPPING.ADDREPORT}
        element={
          <ProtectedRoute
            component={AddRolesReport}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />

      <Route
        path={URL_MAPPING.NOTIF}
        element={
          <ProtectedRoute
            component={Notif}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />

      <Route
        path={URL_MAPPING.MASTERSYNC}
        element={
          <ProtectedRoute
            component={MasterSync}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.AUTH}
        element={
          <ProtectedRoute
            component={Auth}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ROLE_EMPLOYEE}
        element={
          <ProtectedRoute
            component={RoleEmployee}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ROLEPERMISSION}
        element={
          <ProtectedRoute
            component={RolePermissions}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />


      <Route
        path={URL_MAPPING.SALES}
        element={
          <ProtectedRoute
            component={Sales}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />

      <Route
        path={URL_MAPPING.ROADNET}
        element={
          <ProtectedRoute
            component={RoadnetSync}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ROUTE_PLANNING_GENERATE}
        element={
          <ProtectedRoute
            component={RoutePlanningGenerate}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.ASSIGNLMDTERRITORY}
        element={
          <ProtectedRoute
            component={AssignLMDTeeritory}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.LMDTERRITORY}
        element={
          <ProtectedRoute
            component={LMDTerritory}
            allowedRoles={[...ROLE_GROUPS.ZAMZAM_ADMIN]}
          />
        }
      />
      <Route
        path={URL_MAPPING.INVENTORY}
        element={
          <ProtectedRoute
            component={DashboardZamzam}
            allowedRoles={[
              ...ROLE_GROUPS.ZAMZAM_ADMIN,
              ...ROLE_GROUPS.ZAMZAM_INVENTORY,
            ]}
          />
        }
      />
      <Route
        path={URL_MAPPING.CREATEORDER}
        element={
          <ProtectedRoute
            component={NewCreateOrder}
            allowedRoles={[
              ...ROLE_GROUPS.ZAMZAM_ADMIN,
              ...ROLE_GROUPS.ZAMZAM_ORDER,
            ]}
          />
        }
      />
      <Route
        path={URL_MAPPING.FINANCE}
        element={
          <ProtectedRoute
            component={Finance}
            allowedRoles={[
              ...ROLE_GROUPS.ZAMZAM_ADMIN,
              ...ROLE_GROUPS.ZAMZAM_FINANCE,
            ]}
          />
        }
      />
      <Route
        path={URL_MAPPING.EDITORDERHISTORY(":id")}
        element={
          <ProtectedRoute
            component={EditOrderHistory}
            allowedRoles={[
              ...ROLE_GROUPS.ZAMZAM_ADMIN,
              ...ROLE_GROUPS.ZAMZAM_ORDER,
            ]}
          />
        }
      />
      <Route path={URL_MAPPING.SURVEY} element={<Survey />} />
      <Route path={URL_MAPPING.DYNAMIC} element={<Dynamic />} />
      <Route
        path={URL_MAPPING.ORDERHISTORY}
        element={
          <ProtectedRoute
            component={OrderHistory}
            allowedRoles={[
              ...ROLE_GROUPS.ZAMZAM_ADMIN,
              ...ROLE_GROUPS.ZAMZAM_ORDER,
            ]}
          />
        }
      />
      <Route
        path={URL_MAPPING.MANAGEADDR}
        element={
          <ProtectedRoute
            component={ManageAddr}
            allowedRoles={[
              ...ROLE_GROUPS.ZAMZAM_ADMIN,
              ...ROLE_GROUPS.ZAMZAM_ADDRESS,
            ]}
          />
        }
      />
      <Route
        path={URL_MAPPING.KAKRREPORT}
        element={
          <ProtectedRoute
            component={KAKRReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.STOCKREPORT}
        element={
          <ProtectedRoute
            component={StockReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SUPERVISORDASHBOARD}
        element={
          <ProtectedRoute
            component={SupervisorDashboard}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SUPERVISORACTIVITYREPORT}
        element={
          <ProtectedRoute
            component={SupervisorActivityReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }

      />

      <Route
        path={URL_MAPPING.SUPERVISORVISITREPORT}
        element={
          <ProtectedRoute
            component={SupervisorVisitReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SUPERVISORCUSTOMERCREATION}
        element={
          <ProtectedRoute
            component={SupervisorCustomerCreation}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SUPERVISORLOCATIONCAPTURE}
        element={
          <ProtectedRoute
            component={SupervisorLocationCapture}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SUPERVISORPOREPORT}
        element={
          <ProtectedRoute
            component={SupervisorPOReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SUPERVISORCOLLECTIONREPORT}
        element={
          <ProtectedRoute
            component={SupervisorCollectionReport}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SUPERVISORMAP}
        element={
          <ProtectedRoute
            component={SupervisorMapView}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.SUPERVISORCOLLECTIONAUDIT}
        element={
          <ProtectedRoute
            component={SupervisorCollectionAudit}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.OTPGENERATION}
        element={
          <ProtectedRoute
            component={OtpGeneration}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.TARGETKPI}
        element={
          <ProtectedRoute
            component={DashboardKpi}
            allowedRoles={[...ROLE_GROUPS.PRESELLER_SALESMAN_SUPERVISOR]}
          />
        }
      />
      <Route
        path={URL_MAPPING.DELIVERYHEATMAP}
        element={
          <ProtectedRoute
            component={DeliveryHeatmap}
            allowedRoles={[...ROLE_GROUPS.DELIVERY_DRIVER]}
          />
        }
      />

    </Routes>
  );
};

export default AllRoutes;